module.exports = __webpack_public_path__ + "img/ewm_ms_ios.7e2dafd6.png";